document.addEventListener("DOMContentLoaded", function () {
  function replaceAusText() {
    document.querySelectorAll('span.text').forEach(function (el) {
      if (el.textContent.trim() === 'Aus') {
        el.textContent = 'ab';
      }
    });
  }

  replaceAusText();

  const observer = new MutationObserver(replaceAusText);
  observer.observe(document.body, { childList: true, subtree: true });
});
